import { useEffect, useRef } from 'react';

export function useSpotlight() {
  const spotRef = useRef(null);

  useEffect(() => {
    const spot = spotRef.current;
    if (!spot) return;
    let sx = 0, sy = 0, tx = 0, ty = 0;
    let rafId;

    const onMove = (e) => { tx = e.clientX; ty = e.clientY; spot.style.opacity = 1; };
    const onLeave = () => { spot.style.opacity = 0; };
    const loop = () => {
      sx += (tx - sx) * 0.15;
      sy += (ty - sy) * 0.15;
      spot.style.left = sx + 'px';
      spot.style.top = sy + 'px';
      rafId = requestAnimationFrame(loop);
    };

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseleave', onLeave);
    rafId = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseleave', onLeave);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return spotRef;
}
